import { render, staticRenderFns } from "./smart_route_assignments.vue?vue&type=template&id=463ef3ed&scoped=true&"
import script from "./smart_route_assignments.vue?vue&type=script&lang=js&"
export * from "./smart_route_assignments.vue?vue&type=script&lang=js&"
import style0 from "./smart_route_assignments.vue?vue&type=style&index=0&id=463ef3ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ef3ed",
  null
  
)

export default component.exports